module.exports = __webpack_public_path__ + "img/beikelogopng.3a367abc.png";